// src/components/services/PricingEditor.js
import React, { useEffect, useMemo, useState } from "react";
import { DollarSign } from "lucide-react";

const COLORS = {
  text: "#1C1C1E",
  subtext: "#6B7280",
  border: "#E5E5EA",
  bg: "#FFFFFF",
  muted: "#F7F7F8",
  focus: "#FFD9E1",
};

export default function PricingEditor({ value, onChange }) {
  // we only care about a single flat price now
  const [amount, setAmount] = useState(value?.flatUSD ?? "");

  // keep in sync when drawer opens or store changes
  useEffect(() => {
    setAmount(value?.flatUSD ?? "");
  }, [value?.flatUSD]);

  // push up to parent
  useEffect(() => {
    onChange?.({
      ...(value || {}),
      mode: "flat",
      flatUSD: numOrNull(amount),
      markupPct: null,
      minUSD: null,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amount]);

  return (
    <div className="space-y-3">
      <div>
        <label className="text-sm font-medium block mb-1" style={{ color: COLORS.text }}>
          Flat price (USD)
        </label>
        <div
          className="flex items-center rounded-xl px-3"
          style={{
            border: `1px solid ${COLORS.border}`,
            backgroundColor: COLORS.bg,
          }}
        >
          <DollarSign className="w-4 h-4 mr-2" style={{ color: COLORS.subtext }} />
          <input
            inputMode="decimal"
            value={stringify(amount)}
            onChange={(e) => setAmount(sanitizeNumber(e.target.value))}
            placeholder="0.00"
            className="outline-none text-sm py-2 w-full"
            style={{ color: COLORS.text, backgroundColor: "transparent" }}
            onFocus={(e) => (e.currentTarget.style.boxShadow = `0 0 0 4px ${COLORS.focus}`)}
            onBlur={(e) => (e.currentTarget.style.boxShadow = "none")}
          />
        </div>
        <div className="text-xs mt-1" style={{ color: COLORS.subtext }}>
          Guests will see this fixed amount at checkout.
        </div>
      </div>
    </div>
  );
}

/* utils */
function sanitizeNumber(v) {
  const s = String(v).replace(/[^\d.]/g, "");
  const parts = s.split(".");
  if (parts.length > 2) return parts[0] + "." + parts.slice(1).join("");
  return s;
}
function stringify(v) {
  return v === null || v === undefined ? "" : String(v);
}
function numOrNull(v) {
  if (v === "" || v === null || v === undefined) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}
